import React from 'react';
import { Button, Row, Col, Form, Popover, Overlay } from "react-bootstrap";
import { DateInput } from "@blueprintjs/datetime";
import { Label } from "@blueprintjs/core";
import { H5, MenuItem, Switch } from "@blueprintjs/core";
import { Suggest } from "@blueprintjs/select";
import moment from 'moment';
import './AdvancedFilters.scss';

export const renderItem = (item, { handleClick, modifiers, query }) => {
    if (!modifiers.matchesPredicate) {
        return null;
    }
    return (
        <MenuItem
            // className="form-generator-menu-item"
            active={modifiers.active}
            disabled={modifiers.disabled}
            text={item.label ? item.label.toString() : null}
            key={item.label}
            onClick={handleClick}
        />
    );
};
export function createFilm(value, options) {
    return {
        value: value,
        label: value,
    };
}
const filterItems = (query, options) => {
    return options.label ? options.label.toLowerCase().indexOf(query.toLowerCase()) !== -1 : [];
};

export const renderCreateFilmOption = (
    query: string,
    active: boolean,
    handleClick: React.MouseEventHandler<HTMLElement>,
) => (
    <MenuItem
        icon="add"
        text={`Create "${query}"`}
        active={active}
        onClick={handleClick}
        shouldDismissPopover={false}
    />
);

const maybeCreateNewItemFromQuery = true ? createFilm : undefined;
const maybeCreateNewItemRenderer = true ? renderCreateFilmOption : null;
const renderInputValue = (options) => options.label;

const AdvancedFilters = ({ onSearch, intakeMonthSearch,intakeYearSearch, members, sourceName, sourceSearch, onChangeInput, assignedIdSearch, leadStatusSearch,
    children, showLargeModal, id, width, studentStartDate, studentEndDate, universitySearch, courseSearch, zoomabroadUniversity,
    universitySearchObj, applicationStatusSearch, applicationStatus, supportStaffIdSearch, supportMembers, user }) => {
    const style = {};
    if (width) {
        style.width = width;
        style.maxWidth = width;
    }
    let zaUniversityData = []
    if (zoomabroadUniversity && zoomabroadUniversity.list) {
        for (let i = 0; i < zoomabroadUniversity.list.length; i++) {
            const data = {};
            data.value = zoomabroadUniversity.list[i].id;
            data.label = zoomabroadUniversity.list[i].name;
            let index = zaUniversityData.findIndex(x => x.value == data.value);
            index === -1 ? zaUniversityData.splice(0, 0, data) : console.log("object already exists")
        }
    }
    return (
        <div className="slide">
            {/* ref={ref} content {...props} */}
            <Row>
                <Col>
                    {user && user ?
                        <Form.Group >
                            <Form.Control
                                className={user.is_counselor ? `disable-filter` : `righ-side-filter`}
                                name={"assignedIdSearch"}
                                as="select"
                                disabled={user.is_counselor ? true : false}
                                placeholder="Status"
                                value={assignedIdSearch ? assignedIdSearch : ''}
                                onChange={(event) => onChangeInput(event.target.name, event.target.value, event)}
                            >
                                {
                                    members && members.length ? members.map((members) => {
                                        return (
                                            <option value={members.user_id}>{members.first_name}</option>
                                        )
                                    })
                                        : ''}

                            </Form.Control>
                        </Form.Group>
                        : ''}
                </Col>
                {user && user ?
                    <Col>
                        <Form.Group >
                            <Form.Control
                                className={user.is_counselor ? `disable-filter` : `righ-side-filter`}
                                name={"supportStaffIdSearch"}
                                as="select"
                                disabled={user.is_counselor ? true : false}
                                placeholder="Status"
                                value={supportStaffIdSearch ? supportStaffIdSearch : ''}
                                onChange={(event) => onChangeInput(event.target.name, event.target.value, event)}
                            >
                                {
                                    supportMembers && supportMembers.length ? supportMembers.map((supportMembers) => {
                                        return (
                                            <option value={supportMembers.user_id}>{supportMembers.first_name}</option>
                                        )
                                    })
                                        : ''}

                            </Form.Control>
                        </Form.Group >

                    </Col>
                    : ''}

            </Row>
            <Row>
                <Col>
                    <Form.Control
                        className="righ-side-filter"
                        name={"leadStatusSearch"}
                        as="select"
                        placeholder="Status"
                        value={leadStatusSearch ? leadStatusSearch : ''}
                        onChange={(event) => onChangeInput(event.target.name, event.target.value)}
                    >
                        <option value="">Select Status</option>
                        <option value="international">International</option>
                        <option value="subscriber">Subscriber</option>
                        <option value="ringing">Ringing</option>
                        <option value="others">Others</option>
                        <option value="lead">Lead</option>
                        <option value="hot_lead">Hot Lead</option>
                        <option value="customer">Customer</option>
                        <option value="beyond_intake">Beyond Intake</option>
                    </Form.Control>
                </Col>

                <Col>
                    <Form.Control
                        className="righ-side-filter"
                        name={"sourceSearch"}
                        as="select"
                        placeholder="Status"
                        value={sourceSearch ? sourceSearch : ''}
                        onChange={(event) => onChangeInput(event.target.name, event.target.value)}
                    >
                        {
                            sourceName && sourceName.length ? sourceName.map((members) => {
                                return (
                                    <option value={members.id}>{members.source_short_name}</option>
                                )
                            })
                                : ''}
                    </Form.Control>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Control
                        className="righ-side-filter"
                        name={"intakeMonthSearch"}
                        as="select"
                        placeholder="Status"
                        value={intakeMonthSearch ? intakeMonthSearch : ''}
                        onChange={(event) => onChangeInput(event.target.name, event.target.value)}
                    >
                        <option value="">Select Intake</option>
                        <option value="january">January</option>
                        <option value="february">February</option>
                        <option value="march">March</option>
                        <option value="april">April</option>
                        <option value="may">May</option>
                        <option value="june">June</option>
                        <option value="july">July</option>
                        <option value="august">August</option>
                        <option value="september">September</option>
                        <option value="october">October</option>
                        <option value="november">November</option>
                        <option value="december">December</option>
                    </Form.Control>
                </Col>
                
                <Col>
                    <Form.Control
                        className="righ-side-filter"
                        name={"intakeYearSearch"}
                        as="select"
                        placeholder="Status"
                        value={intakeYearSearch ? intakeYearSearch : ''}
                        onChange={(event) => onChangeInput(event.target.name, event.target.value)}
                    >
                        <option value="">Select Intake Year</option>
                        <option value="2016">2016</option>
                        <option value="2017">2017</option>
                        <option value="2018">2018</option>
                        <option value="2019">2019</option>
                        <option value="2020">2020</option>
                        <option value="2021">2021</option>
                        <option value="2022">2022</option>
                        <option value="2023">2023</option>
                        <option value="2024">2024</option>
                        <option value="2025">2025</option>
                        <option value="2026">2026</option>
                        <option value="2027">2027</option>
                        <option value="2028">2028</option>
                        <option value="2029">2029</option>
                        <option value="2030">2030</option>
                    </Form.Control>
                </Col>
                </Row>
                <Row>
                <Col>
                    <Form.Control
                        className="righ-side-filter"
                        name={"applicationStatusSearch"}
                        as="select"
                        placeholder="Status"
                        value={applicationStatusSearch ? applicationStatusSearch : ''}
                        onChange={(event) => onChangeInput('applicationStatusSearch', event.target.value)}
                    >
                        {
                            applicationStatus && applicationStatus.length ? applicationStatus.map((applications) => {
                                return (
                                    <option value={applications.id}>{applications.key}</option>
                                )
                            })
                                : ''}
                        {/* <option value="">Select appliaction status</option>
                        <option value="Visa Rejected">Visa Rejected</option>
                        <option value="1bf083b6ab0049f0bbc4207758e524a2">Offer Letter / Conditional</option>
                        <option value="Visa Appointment Book">Visa Appointment Book</option>
                        <option value="Invoice">Invoice</option>
                        <option value="Visa Applied">Visa Applied</option>
                        <option value="Enrolled In University">Enrolled In University</option>
                        <option value="Application">Application</option>
                        <option value="Fee Deposit">Fee Deposit</option>
                        <option value="Post Arrival Services">Post Arrival Services</option>
                        <option value="Inprogress">Inprogress</option>
                        <option value="Pre Departure Pack">Pre Departure Pack</option>
                        <option value="Lost">Lost</option>
                        <option value="Unconditional Offer Letter">Unconditional Offer Letter</option>
                        <option value="Visa Granted">Visa Granted</option>
                        <option value="University Assessment / Interview">University Assessment / Interview</option>
                        <option value="Visa Documents Checked">Visa Documents Checked</option>
                        <option value="CAS Applied">CAS Applied</option>
                        <option value="CAS Received">CAS Received</option>
                        <option value="Balance Fee Payment">Balance Fee Payment</option> */}
                    </Form.Control>
                </Col>
                {/* <Col>
                        <DateInput
                            className="start-date"
                            formatDate={date => moment(date).format("DD/MM/YYYY")}
                            onChange={(date) => onChangeInput("studentStartDate", date)}
                            parseDate={str => new Date(str)}
                            placeholder={"DD/MM/YYYY"}
                            defaultValue={new Date()}
                            maxDate={new Date('1/1/2030')}
                            value={studentStartDate ? studentStartDate : new Date()}
                        />
                    
                </Col>
                <Col>
                        <DateInput
                            className="start-date"
                            formatDate={date => moment(date).format("DD/MM/YYYY")}
                            onChange={(date) => onChangeInput("studentEndDate", date)}
                            parseDate={str => new Date(str)}
                            placeholder={"DD/MM/YYYY"}
                            defaultValue={new Date()}
                            maxDate={new Date('1/1/2030')}
                            value={studentEndDate ? studentEndDate : new Date()}
                        />

                </Col> */}
                <Col>
                    <Suggest
                        className="righ-side-filter"

                        // createNewItemFromQuery={maybeCreateNewItemFromQuery}
                        // createNewItemRenderer={maybeCreateNewItemRenderer}
                        items={zaUniversityData ? zaUniversityData : []}
                        itemRenderer={renderItem}
                        noResults={<MenuItem disabled={true} text="No results." />}
                        filterable={true}
                        minimal={true}
                        itemPredicate={filterItems}
                        selectedItem={universitySearchObj ? universitySearchObj : 'select'}
                        inputValueRenderer={renderInputValue}
                        inputProps={{ placeholder: 'Search university' }}
                        onItemSelect={(e) => {
                            const event = {
                                target: {
                                    value: e,
                                }
                            }
                            onChangeInput('universitySearch', event.target.value)
                        }}
                    />
                </Col>
                
            </Row>
            <Row>
                <Col>
                    <input
                        name={"courseSearch"}
                        value={courseSearch ? courseSearch : ""}
                        onChange={(event) => onChangeInput(event.target.name, event.target.value)}
                        // onKeyPress={this.handleKeyPress}
                        className="bp3-input righ-side-filter" modifier type="search"
                        placeholder="Search course" dir="auto" />
                </Col>
            </Row>
            <Row style={{ textAlign: 'center' }}>
                <Col style={{ paddingTop: 10 }}>
                    <Button className="search-button btn btn-info" disabled={!(leadStatusSearch || assignedIdSearch || supportStaffIdSearch || sourceSearch || intakeMonthSearch || intakeYearSearch || studentStartDate || studentEndDate || universitySearch || courseSearch || applicationStatusSearch)} onClick={onSearch} >Search</Button>
                </Col>
            </Row>

        </div>
    );
};
export default AdvancedFilters;